import React from 'react';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';

/**
 * 获取文本图层背景样式
 *
 * @param layer - 图层属性
 */
export const getBackgroundStyle = (layer: ILayerProps) => {
    const data = layer.data as ITextLayerProps;
    const { textBackground = [] } = data;

    const style = {} as React.CSSProperties;

    if (textBackground.length === 0) return style;

    const { color, hidden, roundWeight: radius } = textBackground[0];
    if (hidden) return style;

    style.backgroundColor = color;
    style.borderRadius = radius;

    return style;
};

/**
 * 获取文本图层翻转样式
 *
 * @param layer - 图层属性
 */
export const getFlipStyle = (layer: ILayerProps) => {
    const { flipH = false, flipV = false } = layer;

    const styles: React.CSSProperties = {};

    if (!flipH && !flipV) {
        return styles;
    }

    const rx180 = 'scaleX(-1)';
    const ry180 = 'scaleY(-1)';

    if (flipH) styles.transform = rx180;

    if (flipV) {
        styles.transform = styles.transform ? styles.transform + ' ' + ry180 : ry180;
    }

    return styles;
};

/**
 * 获取文本图层字体子集
 *
 * @param layer - 图层属性
 */
export const getFontFamilySubset = (layer: ILayerProps) => {
    const fontFamilyMap = layer.__runtime?.fontFamilyMap || {};
    const layerData = layer.data as ITextLayerProps;
    const { fontFamily } = layerData;

    return fontFamilyMap[fontFamily] || fontFamily;
};
